import { MortgageProductFeeType } from '../generated/resolvers'

export const currentMortgageProductFeeTypes = [
  MortgageProductFeeType.DeedsReleaseFee,
  MortgageProductFeeType.RedemptionAdminFee,
]
